import React from 'react';
import { AngleDownIcon } from './svg/AmsaleIcons';

function MobileLinks({ mainMenu }) {
  const stringParameterize = function (str1) {
    return str1.trim().toLowerCase().replace(/[^a-zA-Z0-9 -]/, '').replace(/\s/g, '-');
  };

  const closeSubNav = () => {
    const container = document.querySelector('.mobile-subnav.active');
    if (container) {
      container.style.height = '0px';
      container.addEventListener('transitionend', () => {
        container.classList.remove('active');
      }, {
        once: true,
      });
    }
  };

  const handleAccordionToggle = (event, subNav) => {
    const container = document.querySelector(`.${subNav}`);
    closeSubNav();

    if (!container.classList.contains('active')){
      container.classList.add('active');
      container.style.height = 'auto';
      const height = `${container.clientHeight}px`;
      container.style.height = '0px';

      setTimeout(() => {
        container.style.height = height;
      }, 0);
    }
  };

  return Object.keys(mainMenu).map((key) => {
    if (mainMenu[key].children !== null && mainMenu[key].children.length > 0) {
      return (
        <li className="list-item" role="menuitem" key={`mobile-${stringParameterize(mainMenu[key].name)}`}>
          <div className="top-level-link-wrapper">
            <a href={mainMenu[key].url} className={`top-level-link top-level-link--${stringParameterize(mainMenu[key].name)}`}
               role="button"
            >
              {mainMenu[key].name}
            </a>

            <div className="top-link-btn" onClick={(e) => handleAccordionToggle(e, `subnav-${stringParameterize(mainMenu[key].name)}`)}>
              <AngleDownIcon />
            </div>
          </div>

          <ul className={`main-submenu mobile-subnav subnav-${stringParameterize(mainMenu[key].name)}`} role="menu">
            {mainMenu[key].children.map((childLink) => (
              <li role="none" key={`mobile-${stringParameterize(childLink.name)}`}>
                <a
                  className="subnav-link"
                  href={childLink.url}
                  role="menuitem"
                  data-toplevel-link={`top-level-link--${stringParameterize(mainMenu[key].name)}`}
                >
                  {childLink.name}
                </a>
              </li>
            ))}
          </ul>
        </li>
      );
    }
    return (
      <li className="list-item normal-link" role="none" key={`mobile-${stringParameterize(mainMenu[key].name)}`}>
        <a className="mobile-link" href={mainMenu[key].url} role="menuitem">
          {mainMenu[key].name}
        </a>
      </li>
    );
  });
}

export default MobileLinks;
